export default "__VITE_ASSET__C2Cdud_N__"